import { useEffect as e, useRef as t } from "react";
//#region src/hooks/useOutsideClose.ts
function n(n, { enabled: r, onClose: i }) {
	let a = t(i);
	a.current = i, e(() => {
		if (!r) return;
		let e = (e) => {
			n.current?.contains(e.target) || a.current();
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, [r, n]);
}
//#endregion
export { n as useOutsideClose };
